import { lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import PhoneInvitation from '../modules/Auth/pages/PhoneInvitation'

const PhoneClaim = lazy(() => import('../modules/Auth/pages/PhoneClaim'))
const Demographics = lazy(() => import('../modules/Demographics/pages/Demographics'))
const DemographicsMinor = lazy(() => import('../modules/Demographics/pages/DemographicsMinor'))
const Intake = lazy(() => import('../modules/Intake/pages/Intake'))
const OptOut = lazy(() => import('../modules/OptOut/pages/OptOut'))
const OptIn = lazy(() => import('../modules/OptIn/pages/OptIn'))
const PatientPortal = lazy(() => import('../modules/PatientPortal/routes/PatientPortal'))
const NotFound = lazy(() => import('../modules/NotFound'))
const PatientSurvey = lazy(() => import('../modules/PatientPortal/pages/Complete-Profile-Survey'))
const MedicalHistorySurvey = lazy(() => import('../modules/PatientPortal/pages/MedicalHistorySurvey'))
const LabDocument = lazy(() => import('../modules/LabDocument/pages/LabDocument'))
const LabVisit = lazy(() => import('../modules/LabVisit/pages/LabVisit'))
const FreeLabs = lazy(() => import('../modules/FreeLabs/pages/FreeLabs'))

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path='/'
        element={
          <Navigate
            to='/patient-portal/register'
            replace
          />
        }
      />
      <Route
        path='/demographics'
        element={<Demographics />}
      />
      <Route
        path='/demographics-minor'
        element={<DemographicsMinor />}
      />
      <Route
        path='/intake'
        element={<Intake />}
      />
      <Route
        path='/opt-out'
        element={<OptOut />}
      />
      <Route
        path='/rejoin'
        element={<OptIn />}
      />
      <Route
        path='/invitations'
        element={<PhoneInvitation />}
      />
      <Route
        path='/phone-claim'
        element={<PhoneClaim />}
      />
      <Route
        path='/survey/:token'
        element={<PatientSurvey />}
      />
      <Route
        path='/medical-history-survey'
        element={<MedicalHistorySurvey />}
      />
      <Route
        path='/labs/doc/:token'
        element={<LabDocument />}
      />
      <Route
        path='/labs/visit/:token'
        element={<LabVisit />}
      />
      <Route
        path='/free-labs'
        element={<FreeLabs />}
      />
      <Route
        path='/patient-portal/*'
        element={<PatientPortal />}
      />
      <Route
        path='/*'
        element={<NotFound />}
      />
    </Routes>
  )
}

export default AppRoutes
